/*
 * @nevware21/ts-async
 * https://github.com/nevware21/ts-async
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
import { dumpObj, getDocument, safeGetLazy, getInst } from "@nevware21/ts-utils";
var DISPATCH_EVENT = "dispatchEvent";
var _hasInitEvent;
/**
 * @internal
 * @ignore
 * @param target
 * @param evtName
 * @param populateEvent
 * @param useNewEvent
 */
export function emitEvent(target, evtName, populateEvent, useNewEvent) {
  var doc = getDocument();
  !_hasInitEvent && (_hasInitEvent = safeGetLazy(function () {
    var evt;
    if (doc && doc.createEvent) {
      evt = doc.createEvent("Event");
    }
    return !!evt && evt.initEvent;
  }, null));
  var theEvt = _hasInitEvent.v ? doc.createEvent("Event") : useNewEvent ? new Event(evtName) : {};
  populateEvent && populateEvent(theEvt);
  if (_hasInitEvent.v) {
    theEvt.initEvent(evtName, false, true);
  }
  if (theEvt && target[DISPATCH_EVENT]) {
    target[DISPATCH_EVENT](theEvt);
  } else {
    var handler = target["on" + evtName];
    if (handler) {
      handler(theEvt);
    } else {
      var theConsole = getInst("console");
      theConsole && (theConsole["error"] || theConsole["log"])(evtName, dumpObj(theEvt));
    }
  }
}
